import axios from 'axios'
import { PAYMENTS_API_GATEWAY } from 'shared/envs'

import { httpClientFactory } from '~/domains/platform/infra/http/http-client-factory'
import { transformResponse } from '~/domains/platform/infra/http/http-helpers'
import { responseUnauthorizedAccessInterceptor } from '~/domains/platform/infra/http/interceptors/unauthorized-access-interceptor'

export const httpClientFmaPayments = httpClientFactory({
  baseURL: PAYMENTS_API_GATEWAY(),
  transformResponse: [...(axios.defaults.transformResponse as any[]), transformResponse],
  responseErrorInterceptors: [responseUnauthorizedAccessInterceptor]
})
